




































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import EntityType from '@/models/Shared/EntityType';
import PeriodType from '@/models/Shared/PeriodType';
import InterestRateType from '@/models/Products/InterestRateType';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import SecondaryWalletsCreateDialog from '@/components/Products/ProductSettings/SecondaryWallets/Savings/SecondaryWalletsCreateDialog.vue';
import SecondaryWalletsEditSettingsDialog from '@/components/Products/ProductSettings/SecondaryWallets/Savings/SecondaryWalletsEditSettingsDialog.vue';
import SecondaryWalletsEditInterestSettingsDialog from '@/components/Products/ProductSettings/SecondaryWallets/Savings/SecondaryWalletsEditInterestSettingsDialog.vue';
import SecondaryWalletType from '@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletType';
import Currency from '@/filters/Currency';
import PostingScheduleType from '@/models/Shared/PostingScheduleType';

@Component({ name: 'SecondaryWalletsList', components: { SecondaryWalletsCreateDialog, SecondaryWalletsEditSettingsDialog, SecondaryWalletsEditInterestSettingsDialog } })
export default class extends SaascadaVue {

    InterestRateType = InterestRateType;
    EntityType = EntityType;
    PeriodType = PeriodType;
    headers = [
        { text: this.$t('pageText.products.fields.name'), sortable: false }
    ];
    secondaryWalletTypesPage = 1;

    @Prop({ required: true })
    entityType: EntityType;

    get currentSecondaryWallet() {
        return ProductDetailsModule.currentSecondaryWallet;
    }

    get secondaryWallets() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.product.secondaryWalletSettings.secondaryWalletTypes;
        }
        return ProductIssueDetailsModule.productIssue.secondaryWalletSettings.secondaryWalletTypes;
    }

    get totalSecondaryWalletTypesPages() {
        // Calculating this in the component instead of in the module because we aren't
        // actually paginating on the API, just the secondaryWallets array
        return  Math.ceil(this.secondaryWallets.length/this.pageSize);
    }

    get rateSourceRate() {
        // This is not currently provided in the API so calculate it manually
        return this.currentSecondaryWallet.depositInterestSettings.cumulativeRateValue - this.currentSecondaryWallet.depositInterestSettings.rateValue;
    }

    get cumulativeRateCalculationText() {
        // A text representation of the cumulative rate calculation
        return `${this.currentSecondaryWallet.depositInterestSettings.rateSourceIdentifier.entityName} ${this.rateSourceRate}% + ${this.$t('pageText.products.fields.rateValue')} ${this.currentSecondaryWallet.depositInterestSettings.rateValue}%`;
    }

    get pageSize() {
        return ProductDetailsModule.pageSize;
    }

    get isInterestSettingsAvailable () {
        return !!this.currentSecondaryWallet.depositInterestSettings;
    }

    get isFixedSchedule() {
        return this.currentSecondaryWallet.depositInterestSettings.postingScheduleType === PostingScheduleType.FixedSchedule;
    }

    updateCurrentSecondaryWallet(secondaryWallet: SecondaryWalletType) {
        ProductDetailsModule.updateCurrentSecondaryWallet(secondaryWallet);
    }

}
